import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import "react-big-calendar/lib/css/react-big-calendar.css";
import clienteAxios from '../../config/axios';
import moment from 'moment';
import 'moment/locale/es';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../extras/toastMessages';
import AudienceEventModal from './AudienceEventModal';
import AudienceAgendaComponent from './AudienceAgendaComponent';
import Swal from 'sweetalert2';
import { MSG_ERROR_SERVER } from '../../constants/messages';


//Función principal
const BigCalendar = () => {
	
	const  [events,setEvents ] = useState([]);
	const  [desde,setDesde ] = useState(moment().startOf('month').startOf('week').format("YYYY-MM-DD"));
	const  [hasta,setHasta ] = useState(moment().endOf('month').endOf('week').format("YYYY-MM-DD"));
	const  [audienceId,setAudienceId ] = useState();
	const  [showAudience,setShowAudience ] = useState(false);
	
	const localizer = momentLocalizer(moment);
	
	//Muestra datos de audiencia cuando clickeo en un evento del calendario
	const handleSelectEvent = async (audienceId)=>{
		//Cargo espera
		WaitingMessage('Cargando datos');
		//Seteo el objeto
		setAudienceId(audienceId);
		//Espero un mínimo tiempo, y muestro el modal
		setTimeout(() => {
			setShowAudience(true);
		}, 500);
		
	}
	
	//Manejo cierre de filtro
	const handleCloseAudience = () => {
		//Limpio datos
		setAudienceId(null);
		//Oculto modal
		setShowAudience(false);
	}
	
	//Cuando clickeo Hoy, Anterior o Siguiente
	const handleOnNavigate = (date, view) => {
		if (view === 'month') {
			setDesde(moment(date).startOf('month').startOf('week').format("YYYY-MM-DD"))
			setHasta(moment(date).endOf('month').endOf('week').format("YYYY-MM-DD"))
		}
	}

	// Esta función trae el comoponente de la agenda
	const myAgendaComponentWithProps = (event) => {
		return <AudienceAgendaComponent
			evento={event}
			onSelectAgendaEvent={handleSelectEvent}
		/>
	}

	// Consigo events (audiencias)
	useEffect(() =>{
		//Cargo los eventos
		fetchEvents();
	},[desde,hasta]);
	//Función que carga los eventos
	const fetchEvents = async () => {
		try {
			//Muestro espera
			WaitingMessage('Cargando agenda');
			// Parámetros de consulta: fecha desde y fecha hasta
			const params = {
				desde: desde,
				hasta: hasta
			}
			//Consulta
			const response = await clienteAxios.get(`/audiencia/events`, { params });
			// Cambio a tipo Date() las fechas sino no funciona el "ver más"
			for (let i = 0; i < response.data.length; i++) {
				response.data[i].start = moment(response.data[i].start).toDate();
				response.data[i].end = moment(response.data[i].end).toDate();
			}
			//Seteo los eventos
			setEvents(response.data);
			//Oculto la espesra
			Swal.close();
		} catch (error) {
			const response = error.response;
			let data = {
				data: null,
				message: MSG_ERROR_SERVER
			};
			//Verifico si hay error
			if(response){
				data = response.data;
			}
			//Oculto espera
			Swal.close();
			//Mensaje de error
			ErrorMessage(data.message);
		}
	}
	//Renderizo
	return (
	<React.Fragment>
		<Calendar
			events={events}
			localizer={localizer}
			defaultDate={new Date()}
			defaultView="month"
			style={{ height: "100vh" }}
			onSelectEvent={event => handleSelectEvent(event.audienciaId)}
			onNavigate={handleOnNavigate}
			onView={handleOnNavigate}
			popup
			step={30}
			timeslots={5}
			titleAccessor={(v) => {
				//Return
				return `${moment(v.start).format('HH:mm')} ${v.title}`
			}}
			tooltipAccessor={(v) => {
				//Return
				return `${moment(v.start).format('HH:mm')} Hs.\n${v.title}`
			}}
			eventPropGetter={(v) => {
				//Armo estilo
				var style = {
					fontSize: '11px',
					backgroundColor: v.color,
					foregroundColor: v.textColor
				};
				//Retorno
				return {
					style
				}
			}}
			messages={{
				next:"Siguiente",
				previous:"Atrás",
				today:"Hoy",
				month:"Mes",
				week:"Semana",
				day:"Día",
				showMore: (v) => {
					return `+${v} más`
				}
			}}
			views={['month','week','day','agenda']}
			components = { 
				{
					agenda: { event: myAgendaComponentWithProps } 
				}
			}
			
		/>
		<AudienceEventModal
			show={showAudience}
			handleClose={handleCloseAudience}
			audienceId={audienceId}
		></AudienceEventModal>
	</React.Fragment>
	);
};

export default BigCalendar;